
const LOCALES = {

  _default: {
    weekStart: 1,
    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    formats: {
      LT: 'kk:mm',
    }
  },

  en: {
    weekStart: 1,
    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    formats: {
      LT: 'h.mm a',
    }
  },

  et: {
    weekStart: 1,
    weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
    formats: {
      LT: 'kk:mm',
    }
  },

  fi: {
    weekStart: 1,
    weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
    formats: {
      LT: 'kk.mm',
    }
  },

  ru: {
    weekStart: 1,
    weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    formats: {
      LT: 'H:mm',
    }
  },

  sv: {
    weekStart: 1,
    weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    formats: {
      LT: 'kk:mm',
    }
  },

  nb: {
    weekStart: 1,
    weekdaysShort: 'Søn_Man_Tir_Ons_Tor_Fre_Lør'.split('_'),
    formats: {
      LT: 'kk:mm',
    }
  }
};


export function getLocale (lang) {
  const locale = LOCALES[lang] || LOCALES._default;
  return {
    weekdayShort(day) {
      return locale.weekdaysShort[day];
    },
    weekStart: locale.weekStart,
    LT: locale.formats.LT
  };
}
